<template>
  <v-content>
    <router-view />
    <!-- <dashboard-core-footer /> -->
  </v-content>
</template>

<script>
export default {
  name: 'DashboardCoreView',
  // components: {
  //   DashboardCoreFooter: () => import('./Footer'),
  // },
}
</script>
<style lang="scss">
.hide-pagination-footer {
  .v-data-footer {
    .v-data-footer__select,
    .v-data-footer__pagination,
    .v-data-footer__icons-before,
    .v-data-footer__icons-after,
    span {
      visibility: hidden;
    }
  }
}
.footer-prepend {
  margin-top: -48px;
  height: 44px;
}
</style>
